import type {Rec} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';
import type {ProjectFinancialOverviewResponse} from './types';

export class ProjectFinancialOverviewDataService {
    public static serviceName = 'projectFinancialOverviewDataService';

    public static readonly FINANCIAL_OVERVIEW_ROUTE = 'project-financial-overview';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getFinancialOverview(project: Rec): Promise<ProjectFinancialOverviewResponse> {
        return this.ajaxService
            .createRequest(ProjectFinancialOverviewDataService.FINANCIAL_OVERVIEW_ROUTE)
            .get(transferify({project}));
    }
}